import React from 'react';

import {EntityScoresWidgetGroup} from "./entity-scores-widget.group";
import {EntityScoresWidgetGroupsTitle} from "./entity-scores-widget.groups.title";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {List} from "../../../../core/components/misc/list/list";

export class EntityScoresGroupListProps extends BaseProps {
}

export const EntityScoresWidgetGroups = ({
                                           items,
                                           shouldRenderTitle,
                                           controller,
                                           isLive,
                                           isSideBar
                                         }: EntityScoresGroupListProps) => {
  if (!(items?.length > 0)) {
    return null;
  }

  const titleProps = {
    controller,
    shouldRenderTitle,
    isLive
  }

  const listProps = {
    items: items,
    ListItem: EntityScoresWidgetGroup,
    itemPropName: 'group',
    listItemProps: {
      separateLive: true,
      controller,
      isLive,
      isSideBar
    }
  }

  return (
    <>
      <EntityScoresWidgetGroupsTitle {...titleProps}/>
      <List {...listProps}/>
    </>
  );
};
